<template>
  <footer class="footer">
    <img src="/images/logo.svg" alt="logo" class="logo" />
    <p class="copyright">
      &copy;copyright reserved for
      <span class="highlight">NAC Code</span> Company
    </p>

    <ul class="social">
      <li class="social__item">
        <a
          href="https://www.facebook.com/profile.php?id=100009826119506"
          target="_blank"
          class="social__link"
        >
          <img
            src="/images/footer-facebook.svg"
            alt="facebook"
            class="social__img"
          />
        </a>
      </li>

      <li class="social__item">
        <a
          href="https://www.linkedin.com/in/ahmed-seyam-b7a001204/"
          target="_blank"
          class="social__link"
        >
          <img
            src="/images/footer-linkedin.svg"
            alt="linkedin"
            class="social__img"
          />
        </a>
      </li>

      <li class="social__item">
        <a
          href="https://www.upwork.com/freelancers/~01f85af0db359981b8"
          target="_blank"
          class="social__link"
        >
          <img
            src="/images/footer-upwork.svg"
            alt="upwork"
            class="social__img"
          />
        </a>
      </li>

      <li class="social__item">
        <a
          href="https://github.com/Ahmed-seyam"
          target="_blank"
          class="social__link"
        >
          <img
            src="/images/footer-github.svg"
            alt="github"
            class="social__img"
          />
        </a>
      </li>

      <li class="social__item">
        <a
          href="https://codecanyon.net/user/nac_code/portfolio"
          target="_blank"
          class="social__link"
        >
          <img
            src="/images/footer-envato.svg"
            alt="envato"
            class="social__img"
          />
        </a>
      </li>
    </ul>
  </footer>
</template>
